import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { loaderHandler } from "src/lib/loaderHandler";
import { CoachAthleteProgramsPage } from "src/pages/CoachAthleteProgramsPage";
import { athleteProfileQueryOptions } from "src/queries/athletes";
import { createPrivatePartnershipProgramsRepository } from "src/repositories/programs/createPrivatePartnershipProgramsRepository";

const statusOptions = ["active", "completed"] as const;

const searchSchema = z.object({
  statuses: z.array(z.enum(statusOptions)).optional(),
});

export function statusesToFilter(
  statuses: readonly ("active" | "completed")[],
): "active" | "completed" | undefined {
  if (statuses.length === 1) return statuses[0];

  return undefined;
}

export const Route = createFileRoute(
  "/_auth/_coach/athletes/$athleteId/programs/_tabs/",
)({
  component: RouteComponent,
  validateSearch: searchSchema,
  ssr: true,
  shouldReload: false,
  loaderDeps: ({ search }) => {
    return search;
  },
  async loader({ context, deps, params }) {
    const statuses = deps.statuses ?? [];

    return await loaderHandler(async () => {
      const athleteProfile = await context.queryClient.query({
        ...athleteProfileQueryOptions(params.athleteId),
        staleTime: "static",
      });
      const programsRepository = createPrivatePartnershipProgramsRepository({
        athleteId: params.athleteId,
        partnershipId: athleteProfile.athlete.partnership.id,
      });
      const programs = await context.queryClient.query({
        ...programsRepository.listOptions({
          pageIndex: 0,
          pageSize: 10,
          query: "",
          status: statusesToFilter(statuses),
        }),
        staleTime: "static",
      });

      return {
        data: {
          programs,
          statuses,
        },
      };
    });
  },
});

function RouteComponent() {
  return <CoachAthleteProgramsPage />;
}
